import { registerBlockType, createBlock } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { group } from '@wordpress/icons';

registerBlockType( metadata, {
	/**
	 * An icon property should be specified to make it easier to identify a block.
	 * These can be any of WordPress’ Dashicons, or a custom svg element.
	 */
	icon: group,

	transforms: {
		from: [
			{
				type: 'block',
				blocks: [ 'core/group' ],
				transform: ( attributes, innerBlocks ) => {
					return createBlock(
						'popper/body',
						attributes,
						innerBlocks
					);
				},
			},
		],
	},

	edit: Edit,

	save: ( { attributes } ) => {
		const blockProps = useBlockProps.save( {
			style: {
				width: attributes.width || undefined,
				height: attributes.height || undefined,
			},
		} );

		return (
			<div { ...blockProps }>
				<InnerBlocks.Content />
			</div>
		);
	},
} );
